import { render, staticRenderFns } from "./TruncateCellRender.vue?vue&type=template&id=403fad32&scoped=true"
import script from "./TruncateCellRender.vue?vue&type=script&lang=ts"
export * from "./TruncateCellRender.vue?vue&type=script&lang=ts"
import style0 from "./TruncateCellRender.vue?vue&type=style&index=0&id=403fad32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403fad32",
  null
  
)

export default component.exports